import {Component, Injector, Input, OnInit} from '@angular/core';
import {BaseNewComponents} from '../../base-new-components';
import {ICardVideo} from '../../interfaces/card-video.interface';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.sass']
})
export class VideoPlayerComponent extends BaseNewComponents implements OnInit {
  @Input() public srcYoutube = '';
  @Input() public titleSize = '';
  @Input() public backgroudImageVideo = './assets/img/view/new-video.png';
  @Input() public showButtonMobile = false;
  @Input() public showCards = false;
  @Input() public cards: ICardVideo[] = [];
  @Input() public title = '';
  @Input() public subtitle = '';
  @Input() public linearGradient = '';
  public isOpenFloatVideo = false;
  public cardsInformations: ICardVideo[][] = [];
  public buildBackgroudImageVideo: string;
  constructor(protected injector: Injector) {
    super(injector);
  }
  ngOnInit() {
    if (this.showCards && this.cards.length) {
      this.cardsInformations = [this.cards];
    }
    if (this.linearGradient !== '') {
      this.buildBackgroudImageVideo = `${this.linearGradient}, url(${this.backgroudImageVideo})`;
      return;
    }
    this.buildBackgroudImageVideo = `url(${this.backgroudImageVideo})`;
  }

  cardsInformationsClass(isBold: boolean) {
    return isBold
        ? 'video-player-cards__container-items--item__text-bold'
        : 'video-player-cards__container-items--item__text-normal';
  }

  toggleYoutubeVideo() {
    this.isOpenFloatVideo = !this.isOpenFloatVideo;
  }

  closeModal() {
    this.isOpenFloatVideo = false;
  }
}
